<template>
  <div>
    <div class="tree-tools" v-if="editable">
      <el-button type="text" icon="el-icon-picture-outline" v-if="!pageBgItem" @click="openUploadWin">添加背景</el-button>
      <el-button type="text" icon="el-icon-document-add" @click="onAddLayerGroup">创建分组</el-button>
    </div>
    <div class="tree-layer">
      <el-tree ref="treeRef"
               :data="value"
               :expand-on-click-node="false"
               :highlight-current="true"
               :props="{label:'originName'}"
               :default-expanded-keys="expandedKeys"
               node-key="id"
               :allow-drag="allowDrag"
               :allow-drop="allowDrop"
               @node-drag-start="handleStart"
               @node-drop="handleDrop"
               default-expand-all
               :draggable="true">
        <div class="custom-tree-node" slot-scope="{ node, data }" @click="onItemClick(data)">
                 <span class="layer-tools">
                    <i class="my-icons" v-if="!data.children"
                       :class="[data.hide ? 'myico-hide': 'myico-show']"
                       :title="data.hide ? '已隐藏': '隐藏'" @click.stop="onHideLayer(data)"></i>
                    <i class="el-icon-delete" v-if="allowDel(data)" title="删除图层"
                       @click.stop="onRemoveLayerGroup(node, data)"></i>
                   <i class="el-icon-folder" v-if="data.children"/>
                   <i class="el-icon-tickets" v-if="data.type === 'text'"/>
                   <i class="el-icon-picture-outline" v-if="data.type === 'img'"/>
                 </span>
          <el-input v-if="editTreeNodeMap[data.id]" :autofocus="true" v-model="data.originName"
                    class="tpl-tree-ipt" size="mini"
                    @blur="onNodeNameBlur(data)"></el-input>
          <span v-else @dblclick="onNodeNameDblClick(data)"
                :title="data.originName">{{ data.originName}}</span>
          <i v-if="data.missingFont" class="el-icon-warning c-red c-f-right tree-warn-icon" title="字体缺失" @click="onOpenFont"/>
        </div>
      </el-tree>
      <el-upload class="c-hide" :action="uploadUrl"
                 :show-file-list="false"
                 :auto-upload="true"
                 accept=".png,.jpg"
                 list-type="picture"
                 :on-success="onUploadSuccess"
                 :before-upload="onBeforeUpload">
        <el-button class="size-15 c-btn-color" round ref="uploadRef"
                   size="small">替换背景
        </el-button>
      </el-upload>
    </div>
  </div>
</template>
<script>
    import util from '@/util.js';
    import TUtil from "../../templateGroup/TUtil";
    import {MATERIAL_UPLOAD} from '../../../request/api/fileupload-api';
    import {
        template_type_single,
    } from '@/const.js';
    export default {
        props: {
            value: Array,
            global: Boolean,
            tplData: Object,
            edit: {
                type: Boolean, default: true
            }
        },
        data() {
            return {
                uploadUrl: MATERIAL_UPLOAD,
                uploading: false,
                editTreeNodeMap: {},
                expandedKeys: [],
            };
        },
        computed: {
            editable() {
                let notModuleEditor = !this.global; // 模块组编辑弹框
                return notModuleEditor && this.edit;
            },
            pageBgItem (){
                return this.$store.state.templateGroup.pageBgItem;
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init(){
                this.initTreeNodeEvent();
                this.initUploadEvent();
            },
            initTreeNodeEvent(){
                let self = this;
                let treeDom = self.$refs.treeRef;
                this.eventBus.$on('setCurrentNode', (key, treeClick) => {
                    self.$store.commit('templateGroup/set_left_active_name', ['3']);
                    if (treeDom && !treeClick) { // 点击树节点时，自动展开节点不触发,只有点击编辑区时生效
                        self.expandedKeys = [];
                        self.expandedKeys.push(key);
                        treeDom.setCurrentKey(key);
                    }
                });
            },
            initUploadEvent(){
                let self = this;
                this.eventBus.$on('onReplaceBg', (key, treeClick) => {
                    self.openUploadWin();
                });
            },
            openUploadWin(){
                this.$refs.uploadRef && this.$refs.uploadRef.$el.click();
            },
            allowDel(data) {
                // return data.layerOrigin === 'user' || this.isEmptyArray(data.children);
                return true;
            },
            onNodeNameBlur(data) {
                this.editTreeNodeMap[data.id] = false;
                if(data.children){
                    data.type = data.originName.indexOf('分组') > -1 ? 'group' : '';
                }
                data.noGroupItem = data.originName.indexOf('非模块项') > -1 ? true : null;
            },
            onNodeNameDblClick(data) {
                if (this.editTreeNodeMap.hasOwnProperty([data.id])) {
                    this.editTreeNodeMap[data.id] = true;
                } else {
                    this.$set(this.editTreeNodeMap, data.id, true);
                }
            },
            onItemClick(item) {
                if (!this.editTreeNodeMap[item.id]) {
                    // 之前双击的编辑node,未获取焦点，无法取消编辑状态, 点击其它node，取消编辑
                    this.editTreeNodeMap = {};
                }
                let activeName = null;
                if (item.isModuleGroup) {
                    activeName = '3';
                } else {
                    activeName = item.type === 'img' ? '2' : '1';
                }
                this.$store.commit("templateGroup/set_attr_tab", activeName);
                this.$emit('onItemClick', item);
            },
            onRemoveLayerGroup(node, data) {
                let msg = data.type && ['text', 'img'].indexOf(data.type) > -1 ? '确定删除图层' : '确定删除分组';
                this.$confirm(`${msg} “${data.originName}”`, '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.removeBgItem(data);
                    const parentNode = node.parent;
                    const children = parentNode.data.children || parentNode.data;
                    const index = children.findIndex(d => d.id === data.id);
                    children.splice(index, 1);
                    this.calcParentPosition(parentNode.data);
                }).catch(() => {
                });
            },
            isBgItem(item){
                return template_type_single === this.tplData.type ? item.isBgImg : item.isPageBgImg;
            },
            hasBgItem(item){
                 let hasPageBgItem = null;
                  if(item.children){
                      hasPageBgItem = item.children.some((obj) => {
                          return this.isBgItem(obj);
                      });
                  }else{
                      hasPageBgItem = this.isBgItem(item);
                  }
                  return hasPageBgItem;
            },
            removeBgItem(item){
                let isPageBgItem = this.hasBgItem(item);
                if(isPageBgItem){
                    this.$store.commit('templateGroup/set_bg_item', null);
                }
            },
            getId(id) {
                if (id && id.toString().indexOf('_') > -1) {
                    return id.toString().split('_');
                } else {
                    return [id, 0];
                }
            },
            getMaxIdItem(dataList) {
                if (dataList && dataList.length > 0) {
                    let id = 0, temp, result;
                    dataList.forEach((item) => {
                        temp = this.getId(item.id).reduce((total, num) => {
                            return (+total) + (+num);
                        });
                        if (id < temp) {
                            id = temp;
                            result = item;
                        }
                    });
                    let idArr = this.getId(result.id);
                    let maxId = +idArr[idArr.length - 1];
                    return {maxId: +maxId, parentId: result.parentId};
                } else {
                    return {maxId: 0, parentId: null};
                }
            },
            setNewLayerId(newItem, parentChildren) {
                let {maxId, parentId} = this.getMaxIdItem(parentChildren);
                newItem.id = `${parentId}_${maxId + 1}`;
                newItem.parentId = parentId;
            },
            getMaxZindex(list){
                let idx = 0;
                list && list.forEach((item) => {
                    idx = item.zIndex > idx ? item.zIndex : idx;
                });
                return idx;
            },
            onAddLayerGroup() {
                this.newIndex = this.newIndex ? ++this.newIndex : 1;
                let name = '组' + this.newIndex;
                let newItem = {
                    id: null,
                    layerOrigin: 'user',
                    key: util.getUUID(),
                    name: name,
                    originName: name,
                    width: 0,
                    height: 0,
                    zIndex: this.getMaxZindex(this.value) + 1,
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    children: []
                };
                let selectedNode = this.$refs.treeRef.getCurrentNode();
                if (selectedNode) {
                    let parentData = this.$refs.treeRef.getNode(selectedNode.id).parent.data; // parentData 有可能是最顶层元素value
                    let parentChildren = parentData === this.value ? parentData : parentData.children;
                    let idx = parentChildren.findIndex((item) => {
                        return item === selectedNode;
                    });
                    this.setNewLayerId(newItem, parentChildren);
                    parentChildren.splice(idx, 0, newItem);
                } else {
                    this.setNewLayerId(newItem, this.value);
                    this.value.push(newItem);
                }
            },
            allowDrag(node) { // 模块组不让移动，内容太多，需要更新模块组内所有元素
                return !node.data.isModuleGroup && !this.editTreeNodeMap[node.data.id];
            },
            allowDrop(draggingNode, dropNode, type) {
                let isDir = dropNode.data.type === undefined || dropNode.data.type === null;
                if (type === 'inner' && isDir) {
                    return true;
                }
                if (type === 'prev' || type === 'next') {
                    return true;
                }
                return false;
            },
            isEmptyArray(array) {
                return array === null || array === undefined || array.length === 0;
            },
            handleStart(node) {
                this.dragParent = node.parent;
            },
            handleDrop(draggingNode, dropNode, dropType, ev) {
                var draggData = draggingNode.data, dropData = dropNode.data;
                let sameParent = draggData.parentId === dropData.parentId;
                if (dropType === 'inner') {
                    this.updateNode(draggData, dropNode.data);
                } else if (sameParent) {//同级目录内移动
                    let dataList = dropNode.parent.data.children || dropNode.parent.data;
                    this.updateZindex(dataList);
                } else {
                    this.updateNode(draggData, dropNode.parent.data);
                }
            },
            updateZindex(list) {
                if (list && list.length > 0) {
                    let len = list.length;
                    let reverse = this.tplData.json.reverse === true; // reverse老数据无此属性
                    list.forEach((item, idx) => {
                        if (reverse) {
                            item.zIndex = len - idx;
                        } else {
                            item.zIndex = idx + 1;
                        }
                    });
                }
            },
            updateNode(dragData, parent) {
                let maxId, parentId;
                if (parent === this.value) { //移动到最外层，不需要计算父元素位置，即模板位置
                    let arr = parent.filter((item) => {
                        return item !== dragData;
                    });
                    let obj = this.getMaxIdItem(arr);
                    maxId = obj.maxId;
                    parentId = obj.parentId;
                    this.updateZindex(this.value);
                } else {
                    this.calcParentPosition(parent);
                    let arr = parent.children.filter((item) => {
                        return item !== dragData;
                    });
                    maxId = this.getMaxIdItem(arr).maxId;
                    parentId = parent.id;
                    this.updateZindex(parent.children);
                }
                // 更新id
                dragData.id = `${parentId}_${maxId + 1}`;
                dragData.parentId = parentId;
                if (dragData.children) {
                    this.updateChildrenId(dragData);
                }
                if (this.dragParent && this.dragParent.data !== this.value) {
                    //更新移动节点的父元素大小与位置
                    let parentData = this.dragParent.data;
                    if (parentData.children && parentData.children.length > 0) {
                        this.calcParentPosition(parentData);
                    } else { // 无子元素时，位置0
                        parentData.left = 0;
                        parentData.top = 0;
                        parentData.right = 0;
                        parentData.bottom = 0;
                        parentData.width = 0;
                        parentData.height = 0;
                    }
                }
            },
            sortNumber(a, b) {
                return a - b
            },
            calcParentPosition(parent) {
                let leftArr = [], topArr = [], bottomArr = [], rightArr = [];
                if (parent.children && parent.children.length > 0) {
                    parent.children.forEach((item) => {
                        leftArr.push(+item.left);
                        topArr.push(+item.top);
                        rightArr.push(+item.right);
                        bottomArr.push(+item.bottom);
                    });
                    leftArr.sort(this.sortNumber);
                    topArr.sort(this.sortNumber);
                    rightArr.sort(this.sortNumber);
                    bottomArr.sort(this.sortNumber);
                    parent.left = leftArr[0];
                    parent.top = topArr[0];
                    parent.right = rightArr[rightArr.length - 1];
                    parent.bottom = bottomArr[bottomArr.length - 1];
                    parent.height = parent.bottom - parent.top;
                    parent.width = parent.right - parent.left;
                } else {
                    parent.zIndex = 0;
                    parent.left = 0;
                    parent.top = 0;
                    parent.right = 0;
                    parent.bottom = 0;
                    parent.height = 0;
                    parent.width = 0;
                }
                let node = this.$refs.treeRef.getNode(parent.parentId);
                if (node && node.data !== this.value) {
                    this.calcParentPosition(node.data);
                }
            },
            updateChildrenId(data) {
                data.children && data.children.forEach((item, index) => {
                    item.parentId = data.id;
                    item.id = `${data.id}_${index + 1}`;
                    if (item.children) {
                        this.updateChildrenId(item)
                    }
                })
            },
            onBeforeUpload(file) {
                let result = TUtil.beforeUploadBg(file);
                if (result) {
                    this.uploading = true;
                } else {
                    this.$message.error('请选择png图片');
                }
                return result;
            },
            onUploadSuccess(response) {
                let result = TUtil.uploadSuccessBg(response);
                if(result){
                    let {width, height, url} = result;
                    if(this.pageBgItem){
                        this.pageBgItem.url = url;
                    } else {
                        let bgObj = {
                            width: width,
                            height: height,
                            bottom: height,
                            url: url,
                        }
                        let bgItem = Object.assign({}, TUtil.getEmptyBgData(), bgObj);
                        this.value.push(bgItem);
                        this.$store.commit('templateGroup/set_bg_item', bgItem);
                        this.$message.success('添加成功')
                    }
                    this.$nextTick(() => {
                        this.uploading = false;
                    })
                }
            },
            onHideLayer(item){
                util.setVueAttr(this, item, 'hide', !item.hide);
            },
            onOpenFont(){
                this.eventBus.$emit('onOpenMissingFont')
            }
        }
    }
</script>